import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingLeft: ".5rem !important",
    paddingRight: ".5rem !important",
  },
  settingIcon: {
    color: "#232323",
    display: "flex",
    width: "40px",
    height: "40px",
    justifyContent: "center",
    alignItems: "center",
  },
  mainContainer: {
    marginTop: "50px",
    marginLeft: "10px",
    marginrIGHT: "10px",
  },
  date: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    gap: "20px",
    margin: "5px 0",
  },
  message: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
  },
}));

export default useStyles;
